// // src/apiConfig.js
// const BASE_URL =
//   process.env.NODE_ENV === "production"
//     ? "https://crm.digitalhive.in/api" // Use the actual domain in production
//     : "http://localhost:5004/api"; // Use localhost for development

// export default BASE_URL;
import axios from "axios";
import { toast } from "react-toastify";
import { getAuthToken } from "layouts/authentication/tokenStorage";
import { logoutUser } from "layouts/authentication/authService";

// Get the API base URL (adjust this if needed)
const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://app.saleshive.cloud/api" // Use the actual domain in production
    : "http://localhost:5004/api"; // Use localhost for development

// Create a centralized Axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to dynamically set Authorization header
axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle session expiration
axiosInstance.interceptors.response.use(
  (response) => response, // If response is successful, return it
  (error) => {
    // An old request must not log out a newly signed-in account. A failed
    // anonymous login should also keep its normal form error handling.
    const token = getAuthToken();
    if (error.response?.status === 401 && token &&
        error.config?.headers?.Authorization === `Bearer ${token}`) {
      toast.error("Session expired. Redirecting to login...");
      logoutUser();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
